import { useState, useEffect } from "react";
import BrandElement from "./BrandEelement";
import EmailSignature from "./EmailSignature";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../../../../../services/errorHelper";
import apiClient from '../../../../../../services/apiClient';

export default function CompanyBrand() {

  const [formData, setFormData] = useState({
    companyEmail: "",
    phoneNumber: "",
    companyWebsite: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [companyName, setCompanyName] = useState("Company Name");

  const [companylogo, setCompanylogo] = useState();
  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleBlur = (event) => {
    setCompanyName(event.target.value);
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });


  };




  const handleSubmit = async () => {
    try {
      const response = await apiClient.post(`/setcompanyinfo`, {
        user_id: JSON.parse(localStorage.getItem('user')).user.id,
        formData,
        companyname: companyName,
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contract saved successfully!",
      });
      // navigate("/proposals");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };


  useEffect(() => {
    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);

        setCompanylogo(response.data.usersdetails[0].Main_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.usersdetails[0].Main_Logo : null);

        setCompanyName(response.data.usersdetails[0].companyname);
        setCompanyemail(response.data.usersdetails[0].Company_Email);
        setFname(response.data.usersdetails[0].first_name);
        setLname(response.data.usersdetails[0].last_name);

        setFormData({
          companyEmail: response.data.usersdetails[0].Company_Email,
          phoneNumber: response.data.usersdetails[0].Phone_Number,
          companyWebsite: response.data.usersdetails[0].Company_Website,
        });

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchuserdata();
  }, []);


  return (
    <>
      <div className='tab-pane fade show active company_brand' id='content1'>
        <div className='justify-content-center my-3'>
          {/*================= Start: Company Brand Header Part =================*/}
          <p className='title fw-bolder fs30 my-4'>
            BUILD UP YOUR PROFESSIONAL PRESENCE{" "}
          </p>
          <p className=' fs16  m-0'>Only visible to admin</p>
          {/*================= End: Company Brand Header Part =================*/}

          {/* ================= Start:Company Brand Sections ================= */}
          <div className='companysetting-window-container '>
            <div className=' mt-2'>
              <div className='row'>
                {/*============== Start: Company Brand Section-1 ============== */}
                <div className='mb-3 row col-md-12 bg-white company-setting-box p-lg-3 p-md-2 p-2 my-4 company_brand_form'>
                  <div className='mb-3 col-md-4 pl-5 company_name'>
                    {isEditing ? (
                      <input
                        type='text'
                        value={companyName ? companyName : 'Company Name'}
                        onBlur={handleBlur}
                        onChange={(e) => setCompanyName(e.target.value)}
                        autoFocus
                        className='editable'
                      />
                    ) : (
                      <>
                        <h5>{companyName ? companyName : 'Company Name'}</h5>
                      </>
                    )}
                    <p> {fname} {lname}  </p>
                    <button
                      className='icon border-0 bg-transparent'
                      onClick={handleEditClick}>
                      <i className='fas fa-pen'></i>
                    </button>
                  </div>

                  <div className='mb-3 col-md-7'>
                    <div className='mb-3 '>
                      <label htmlFor='companyEmail' className='form-label'>
                        Company Email
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Company Email'
                        id='companyEmail'
                        name='companyEmail'
                        value={formData.companyEmail}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className='mb-3 '>
                      <label htmlFor='phoneNumber' className='form-label'>
                        Phone Number
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='phoneNumber'
                        name='phoneNumber'
                        placeholder='Phone Number'
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className='mb-3 '>
                      <label htmlFor='companyWebsite' className='form-label'>
                        Company Website
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='companyWebsite'
                        name='companyWebsite'
                        placeholder='Company Website'
                        value={formData.companyWebsite}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className='mb-3 '>

                      <button
                        id='submit-btn'
                        type='button'
                        className='px-5 rounded-pill btn btn-primary btn-lg text-uppercase'
                        onClick={handleSubmit}>
                        Save
                      </button>

                    </div>

                  </div>
                </div>
                {/*============== End: Company Brand Section-1 ============== */}

                {/*============== Start: Company Brand Section-2 ============== */}

                <BrandElement />
                {/*============== End: Company Brand Section-2 ============== */}

                {/*============== Start: Company Brand Section-3 ============== */}

                <EmailSignature />
                {/*============== Emd: Company Brand Section-3 ============== */}
              </div>
            </div>
          </div>
          {/* ================= End:Company Brand Sections ================= */}
        </div>
      </div>
    </>
  );
}
